var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLetterIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 56.46 39.58",
    style: {
      enableBackground: "new 0 0 56.46 39.58"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M55.35,0.5H1.1c-0.33,0-0.6,0.27-0.6,0.6v37.38c0,0.33,0.27,0.6,0.6,0.6h54.25c0.33,0,0.6-0.27,0.6-0.6V1.1 C55.96,0.77,55.68,0.5,55.35,0.5L55.35,0.5z M46.18,5.33L28.23,18.49L10.28,5.33H46.18z M51.13,34.25H5.32V7.67l22.55,16.54 c0.22,0.16,0.5,0.16,0.72,0L51.13,7.67V34.25z M51.13,34.25"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLetterIcon);
export default __webpack_public_path__ + "static/media/letterIcon.ecb485657d1894bc6412a11bbaa7bd2c.svg";
export { ForwardRef as ReactComponent };